// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Org Management ──────────────────────────────────────────────────────── */

.ecr-org-mgmt {
  display: flex;
  flex-direction: column;
}

.ecr-org-mgmt__toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
}

.ecr-org-mgmt__count {
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
}

.ecr-org-mgmt__grid-wrap {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-top: 3px solid #86BC25;
  border-radius: 10px;
  overflow: hidden;
  height: calc(100vh - 320px);
  min-height: 500px;
}

/* Hide DataGrid footer to reduce gap */
.ecr-org-mgmt__grid-wrap .MuiDataGrid-footerContainer {
  display: none;
}

/*
 * modalTOS.css (TOS modal) styles .MuiDataGrid-* globally with !important,
 * leaking a per-row box-shadow, 40px min-height and 16px header font into
 * every DataGrid in the app. These higher-specificity rules neutralize that
 * for the org management grid only.
 */
.ecr-org-mgmt__grid-wrap .MuiDataGrid-root .MuiDataGrid-row {
  box-shadow: none !important;
  border-radius: 0 !important;
  margin-bottom: 0 !important;
  min-height: 64px !important;
  max-height: 64px !important;
}

.ecr-org-mgmt__grid-wrap
  .MuiDataGrid-root
  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)
  > .MuiDataGrid-cell {
  min-height: 64px !important;
  max-height: 64px !important;
  display: flex;
  align-items: center;
}

.ecr-org-mgmt__grid-wrap .MuiDataGrid-columnHeaderTitle {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #111827 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/EcrOpsOrgManagement.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA;;;;;EAKE;AACF;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;;;EAIE,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B","sourcesContent":["/* ── Org Management ──────────────────────────────────────────────────────── */\n\n.ecr-org-mgmt {\n  display: flex;\n  flex-direction: column;\n}\n\n.ecr-org-mgmt__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 14px 16px;\n}\n\n.ecr-org-mgmt__count {\n  font-size: 12px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n.ecr-org-mgmt__grid-wrap {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-top: 3px solid #86BC25;\n  border-radius: 10px;\n  overflow: hidden;\n  height: calc(100vh - 320px);\n  min-height: 500px;\n}\n\n/* Hide DataGrid footer to reduce gap */\n.ecr-org-mgmt__grid-wrap .MuiDataGrid-footerContainer {\n  display: none;\n}\n\n/*\n * modalTOS.css (TOS modal) styles .MuiDataGrid-* globally with !important,\n * leaking a per-row box-shadow, 40px min-height and 16px header font into\n * every DataGrid in the app. These higher-specificity rules neutralize that\n * for the org management grid only.\n */\n.ecr-org-mgmt__grid-wrap .MuiDataGrid-root .MuiDataGrid-row {\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  margin-bottom: 0 !important;\n  min-height: 64px !important;\n  max-height: 64px !important;\n}\n\n.ecr-org-mgmt__grid-wrap\n  .MuiDataGrid-root\n  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)\n  > .MuiDataGrid-cell {\n  min-height: 64px !important;\n  max-height: 64px !important;\n  display: flex;\n  align-items: center;\n}\n\n.ecr-org-mgmt__grid-wrap .MuiDataGrid-columnHeaderTitle {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: #111827 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
